const Location = {
  id: null,
  name: '',
  externalId: '',
  openFromTimeLocal: null,
  openToTimeLocal: null,
  pickupNotes: '',
  deliveryNotes: '',
  address: {
    address1: '',
    address2: '',
    city: '',
    country: '',
    postalCode: '',
    state: ''
  }
};

export default Location;
